<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-select v-model="listQuery['filter[exam_id]']" clearable placeholder="请选择">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="考生名称:">
          <el-input v-model="listQuery['filter[name]']" clearable placeholder="考生名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column label="考试名称">
        <template slot-scope="scope">
          {{scope.row.exam.name}}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名">
      </el-table-column>
      <el-table-column label="性别">
      <template slot-scope="scope">
        {{scope.row.user.gender==1?'男':'女'}}
      </template>
    </el-table-column>
      <el-table-column prop="code" label="学号">
      </el-table-column>
      <el-table-column prop="idcard" label="身份证号">
      </el-table-column>
      <el-table-column prop="mobile" label="联系电话">
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page"
                  @pagination="getData"/>

    </div>
<!--    <el-dialog :visible.sync="dialogVisible" :title="dialogType==='edit'?'编辑考官':'新增考官'">-->
<!--      <el-form :model="student" label-width="80px" label-position="left">-->
<!--        <el-form-item label="姓名" prop="name">-->
<!--          <el-input v-model="student.name" placeholder="姓名"/>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="手机号" prop="mobile">-->
<!--          <el-input v-model="student.mobile" placeholder="手机号"/>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="手机号" prop="mobile">-->
<!--          <el-input v-model="student.mobile" placeholder="手机号"/>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--      <div style="text-align:right;">-->
<!--        <el-button type="danger" @click="dialogVisible=false">取消</el-button>-->
<!--        <el-button type="primary" @click="confirmSave">保存</el-button>-->
<!--      </div>-->
<!--    </el-dialog>-->

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'

    export default {
        components: {Pagination},
        props: {},
        data() {
            return {
                student: {},
                examList: [],
                total: 0,
                dialogType: 'new',
                dialogVisible: false,
                listQuery: {
                    page: 1,
                    per_page: 20,
                    include: 'user,exam',
                },
                tableData: []
            };
        },
        computed: {},
        created() {
            this.getData();
            this.getExam()
        },
        methods: {
            getExam() {
                this.$http.examsList({page_size: 100000}).then(res => {
                    this.examList = res.data;
                })
            },
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            getData() {
                this.$http.getExamStudents(this.listQuery)
                    .then(res => {
                        this.tableData = res.data;
                        this.total = res.meta.total;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleEdit(scope) {
                this.dialogType = 'edit';
                this.dialogVisible = true;
                // this.$http.getExamStudent(scope.row.id, {include: 'user'}).then(res => {
                //     const subjects = [];
                //     this.student = res.data
                //     res.data.subjects.forEach((i, v) => {
                //         subjects.push(i.id)
                //     })
                //     this.student.subjects = subjects
                // })
            },
            confirmSave() {
                const isEdit = this.dialogType === 'edit'
                if (isEdit) {
                    this.$http.updateTeacher(this.student.id, this.student).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        })
                        this.getData()
                    })
                } else {
                    this.$http.addTeacher(this.student).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        })
                        this.getData()
                    })
                }
            },
            handleDelete({$index, row}) {
                this.$confirm('确定要删除此条吗?', '警告', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http.deleteTeacher(row.id).then(res => {
                            this.tableData.splice($index, 1)
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                        });

                    })
                    .catch(err => {
                        console.error(err)
                    })
            },

        },
    };
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/examManage/students.vue